import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import CompletedRequestsView from "./CompletedRequestsView";
import Administrator from "../models/Administrator";
import TextView from "./TextView";
import NOKUser from "../models/NOKUser";
import PendingRequestsView from "./PendingRequestsView";
import { BuildContext } from "../classes/BuildContext";

export interface DashboardPageProps extends BaseUIProps {
  key?: string;
  administrator: Administrator;
  user: NOKUser;
}

class _DashboardPageState extends ObservableComponent<DashboardPageProps> {
  static defaultProps = { administrator: null, user: null };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: DashboardPageProps) {
    super(props);

    this.initState();
  }
  public get administrator(): Administrator {
    return this.props.administrator;
  }
  public get user(): NOKUser {
    return this.props.user;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.updateSyncProperty("administrator", this.props.administrator);

    this.updateSyncProperty("user", this.props.user);

    this.on(["administrator", "user"], this.rebuild);
  }
  public componentDidUpdate(prevProps: DashboardPageProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.administrator !== this.props.administrator) {
      this.updateObservable(
        "administrator",
        prevProps.administrator,
        this.props.administrator
      );

      this.fire("administrator", this);
    }

    if (prevProps.user !== this.props.user) {
      this.updateObservable("user", prevProps.user, this.props.user);

      this.fire("user", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisAlignment: ui.MainAxisAlignment.start,
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        TextView({
          data: "Dashboard",
          style: new ui.TextStyle({
            fontWeight: ui.FontWeight.w700,
            fontSize: cStyle.tTextViewHeadlineThreeFontSizeOn,
          }),
          className: "xe23 hc",
          key: "0",
        }),
        ui.Row({
          mainAxisAlignment: ui.MainAxisAlignment.spaceBetween,
          crossAxisAlignment: ui.CrossAxisAlignment.start,
          children: [
            ui.Container({
              expand: true,
              child: PendingRequestsView({
                user: this.user,
                admin: this.administrator,
              }),
              key: "0",
              className: "xb66 hc h",
            }),
            ui.Container({
              expand: true,
              margin: ui.EdgeInsets.fromLTRB(20.0, 0.0, 0.0, 0.0, new Map()),
              child: CompletedRequestsView({
                user: this.user,
                admin: this.administrator,
              }),
              key: "1",
              className: "x405 hc h",
            }),
          ],
          className: "x61 hc h",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "DashboardPage xf6 hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function DashboardPage(props: DashboardPageProps) {
  return React.createElement(_DashboardPageState, {
    ..._DashboardPageState.defaultProps,
    ...props,
  });
}
